export default "__VITE_ASSET__c97c0b73__"